import {BaseModel} from '../base.model';
import {JsonProperty} from '../json-map.util';
import {LessonModel} from '../lesson/lesson.model';

class CourseModel extends BaseModel {


  title: string = undefined as any;
  description: string = undefined as any;
  subject: string = undefined as any;
  country: string = undefined as any;

  @JsonProperty({ clazz: LessonModel })
  lessons: LessonModel[] = [];

}


export { CourseModel };


